import { memo, useState } from 'react'

import { Text, Icon, AdvancedTooltip } from 'common-components'
import VelocityIcon from 'assets/svgr-icons/Velocity.svg'

import { formatPlaybackSpeedLabel } from './utils'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

interface IProps {
  onToggleMenu: () => void
  playbackSpeed: number
  scrollableParentRef?: React.RefObject<HTMLDivElement | null>
}

const PlaybackSpeedToggler: React.FC<IProps> = ({
  onToggleMenu,
  playbackSpeed,
  scrollableParentRef
}) => {
  const label = formatPlaybackSpeedLabel(playbackSpeed)
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement | null>(null)

  return (
    <Styled.PlaybackSpeedTogglerRoot onClick={onToggleMenu} ref={setWrapperRef}>
      <Styled.PlaybackSpeedTogglerInner $isMobile={isMobile}>
        <Styled.PlaybackSpeedIconSlot>
          <Icon
            icon={<VelocityIcon />}
            size="small"
            color="secondarySemiDark"
          />
        </Styled.PlaybackSpeedIconSlot>
        {isMobile ? null : (
          <Text type="h4" color="secondarySemiDark" lineHeight="20px">
            {label}
          </Text>
        )}
        <AdvancedTooltip
          tooltipText={translate(T.CHANGE_SPEED)}
          tooltipPosition="top"
          btnRef={{ current: wrapperRef }}
          scrollableParentRef={scrollableParentRef}
        />
      </Styled.PlaybackSpeedTogglerInner>
    </Styled.PlaybackSpeedTogglerRoot>
  )
}

export default memo(PlaybackSpeedToggler)
